import { useIntersectionObserver } from '@ab-core-functions/observer';
import { Availabilities } from '@ab-core/availabilities';
import { isLoggedIn } from '@ab-core/hooks';
import { Prices } from '@ab-core/prices';
import { ComparisonCheckbox } from '@ab-core/product-comparison/checkbox';
import type { FC } from 'react';
import React from 'react';
import {
    AdditionalLinksContainer,
    IconsContainer,
    IdsContainer,
    ImageContainer,
    InformationContainer,
    NameContainer,
    OrderContainer,
    PositionTextContainer,
    TagsContainer
} from '../../components';
import type { DefaultScalableProductCardProps } from '../index';
import { getScalablePropsFromDefaultProps } from '../utils';
import { Content, ContentGrid, ContentGridWithBorder, FlexVerticalContent, Header, HorizontalLine } from './styled';

export const ScalableProductCardList: FC<DefaultScalableProductCardProps> = (props) => {
    const { ref, isVisible } = useIntersectionObserver<HTMLDivElement>({
        threshold: 1,
        freezeOnceVisible: true
    });

    const {
        topContent,
        tags,
        image,
        ids,
        icons,
        name,
        availability,
        prices,
        order,
        positionText,
        additionalLinks,
        comparison,
        information,
        bottomContent
    } = getScalablePropsFromDefaultProps({ ...props, isVisible });

    const isUserLoggedIn = isLoggedIn();
    const showPositionText = positionText.scalableStyle?.isVisible && isUserLoggedIn;

    return (
        <>
            {topContent && (
                <>
                    {topContent}
                    <HorizontalLine />
                </>
            )}
            <Header>
                <NameContainer {...name} />
                <div ref={ref} className="flex gap-small3">
                    <IconsContainer {...icons} />
                    <TagsContainer {...tags} />
                </div>
            </Header>

            <Content>
                <ImageContainer {...image} />

                <ContentGrid>
                    <IdsContainer {...ids} />
                    <div>
                        <Availabilities {...availability} />
                    </div>
                    {comparison?.scalableStyle?.isVisible && (
                        <FlexVerticalContent>
                            <HorizontalLine />
                            <div className="mt-small pt-small">
                                <ComparisonCheckbox {...comparison} />
                            </div>
                        </FlexVerticalContent>
                    )}
                </ContentGrid>

                <ContentGridWithBorder>
                    <FlexVerticalContent>
                        {isUserLoggedIn && (
                            <div>
                                <Prices {...prices} />
                            </div>
                        )}
                        <div>
                            <HorizontalLine />
                            <AdditionalLinksContainer {...additionalLinks} />
                        </div>
                    </FlexVerticalContent>
                </ContentGridWithBorder>

                <ContentGridWithBorder>
                    <OrderContainer {...order} />
                    {showPositionText && (
                        <>
                            <HorizontalLine />
                            <PositionTextContainer {...positionText} />
                        </>
                    )}
                </ContentGridWithBorder>
            </Content>

            <InformationContainer {...information} />

            {bottomContent && (
                <>
                    <HorizontalLine />
                    {bottomContent}
                </>
            )}
        </>
    );
};
